/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!************************************************!*\
  !*** ./src/js/components/CustomInputNumber.js ***!
  \************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CustomInputNumber: () => (/* binding */ CustomInputNumber)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomInputNumber = /*#__PURE__*/function (_HTMLElement) {
  function CustomInputNumber() {
    _classCallCheck(this, CustomInputNumber);
    return _callSuper(this, CustomInputNumber, arguments);
  }
  _inherits(CustomInputNumber, _HTMLElement);
  return _createClass(CustomInputNumber, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this$input, _this$input2, _this$input3, _this$incrementButton, _this$decrementButton, _this$input4;
      this.input = this.querySelector('input');
      this.syncInputs = document.querySelectorAll(this.dataset.syncInputSelector);
      this.incrementButton = this.querySelector('[data-increment]');
      this.decrementButton = this.querySelector('[data-decrement]');
      this.min = parseInt((_this$input = this.input) === null || _this$input === void 0 ? void 0 : _this$input.getAttribute('min')) || 0;
      this.max = parseInt((_this$input2 = this.input) === null || _this$input2 === void 0 ? void 0 : _this$input2.getAttribute('max')) || Infinity;
      this.step = parseInt((_this$input3 = this.input) === null || _this$input3 === void 0 ? void 0 : _this$input3.getAttribute('step')) || 1;
      (_this$incrementButton = this.incrementButton) === null || _this$incrementButton === void 0 || _this$incrementButton.addEventListener('click', this.increment.bind(this));
      (_this$decrementButton = this.decrementButton) === null || _this$decrementButton === void 0 || _this$decrementButton.addEventListener('click', this.decrement.bind(this));
      (_this$input4 = this.input) === null || _this$input4 === void 0 || _this$input4.addEventListener('input', this.validateInput.bind(this));
      this.updateDisabled();
    }
  }, {
    key: "increment",
    value: function increment() {
      this.updateInputValue(Math.min(parseInt(this.input.value) + this.step, this.max));
      this.updateDisabled();
    }
  }, {
    key: "decrement",
    value: function decrement() {
      this.updateInputValue(Math.max(parseInt(this.input.value) - this.step, this.min));
      this.updateDisabled();
    }
  }, {
    key: "validateInput",
    value: function validateInput() {
      this.input.value = Math.min(Math.max(parseInt(this.input.value), this.min), this.max);
      this.updateDisabled();
    }
  }, {
    key: "updateInputValue",
    value: function updateInputValue(value) {
      this.input.value = value;
      this.input.dispatchEvent(new Event('input', {
        bubbles: true
      })); // Trigger input event
      this.syncInputs.forEach(function (input) {
        input.value = value;
        input.dispatchEvent(new Event('input', {
          bubbles: true
        })); // Trigger input event
      });
    }
  }, {
    key: "updateDisabled",
    value: function updateDisabled() {
      this.incrementButton.disabled = this.input.value >= this.max;
      this.decrementButton.disabled = this.input.value <= this.min;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('custom-input-number', CustomInputNumber);
/******/ })()
;